import { toRate } from '@/utils/to-rate'

export const formatRate = (rate: number | string) =>
  `${toRate(rate, 'partner-detail formatRate:')}%`
